import PropTypes from "prop-types";

const Button = ({ onClick, text, background }) => {
  return (
    <button className="btn" onClick={onClick} style={{ background }}>
      {text}
    </button>
  );
};

Button.propTypes = {
  text: PropTypes.string,
  background: PropTypes.string,
  onClick: PropTypes.func,
};

export default Button;
